<template>
  <li class="pentagon-member" data-cy="intro-member">{{ member }}</li>
</template>

<script>
export default {
  name: 'Lid',
  props: {
    // The display name exactly as the server formats it.
    member: {
      type: String,
      required: false,
      default: '',
    },
  },
};
</script>

<style>
  .pentagon-member {
    break-inside: avoid;
    line-height: 1.9;
  }
</style>
